import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

export interface HeaderProps {
  children?: React.ReactNode;
}

export const Header = ({ children }: HeaderProps) => {
  return <IgTypography fontWeight={600}>{children}</IgTypography>;
};
